angular.module('app.filters').filter('max', () => (items) => {
    if (items && items.length) {
        let max = items[0];
        for (let i = 1; i < items.length; ++i) {
            if (max < items[i]) {
                max = items[i];
            }
        }
        return max;
    }

    return 0;
});
